export assessorsListTabs from './assessors-list-tabs'

export const tabs = [
  {
    id: 1,
    label: 'Detail',
    intlKey: 'tabs.detail',
    path: '/detail'
  },
  {
    id: 2,
    label: 'Participants',
    intlKey: 'tabs.participants',
    path: '/participants'
  },
  {
    id: 3,
    label: 'Files',
    intlKey: 'tabs.files',
    path: '/files'
  },
   {
     id: 4,
     label: 'History Log',
     intlKey: 'tabs.history_log',
     path: '/history'
   }
]

export const tableHeaders = (expiredWWC) => [
  {
    id: 1,
    label: 'ID',
    intlKey: 'table.id',
    sortableId: 'id'
  },
  {
    id: 2,
    label: 'First Name',
    intlKey: 'table.first_name',
    sortableId: 'person.firstName'
  },
  {
    id: 3,
    label: 'Last Name',
    intlKey: 'table.last_name',
    sortableId: 'person.lastName'
  },
  {
    id: 4,
    label: 'Email',
    intlKey: 'table.email',
    sortableId: 'person.email'
  },
  {
    id: 5,
    label: 'Child protection number',
    intlKey: 'table.child_protection_number',
    sortableId: 'assessorWWC.childProtectionNumber'
  },
  {
    id: 6,
    label: 'Expire day',
    intlKey: 'table.expire_day',
    sortableId: 'assessorWWC.childProtectionExpirationDate'
  },
  {
    id: 7,
    label: 'Assessed Activities',
    intlKey: 'table.assessed_activities'
  },
  {
    id: 8,
    label: 'Organization',
    intlKey: 'table.organization',
    sortableId: 'organization.name'
  },
  {
    id: 9,
    label: 'Status',
    intlKey: 'table.status'
  },
  {
    id: 10,
    label: 'Action',
    intlKey: 'table.action',
    hide: !expiredWWC
  }
]

export const tableRegistrationHeaders = (isActivityRegistration = false) => [
  {
    id: 1,
    label: 'ID',
    intlKey: 'table.id',
   // sortableId: 'assessor.person.id'
  },
  {
    id: 2,
    label: 'First Name',
    intlKey: 'table.first_name',
   // sortableId: 'assessor.person.firstName'
  },
  {
    id: 3,
    label: 'Last Name',
    intlKey: 'table.last_name',
  //  sortableId: 'assessor.person.lastName'
  },
  {
    id: 4,
    label: 'Email',
    intlKey: 'table.email',
  //  sortableId: 'assessor.person.email'
  },
  {
    id: 5,
    label: 'Phone number',
    intlKey: 'table.phone',
    hide: !isActivityRegistration
  },
  {
    id: 6,
    label: 'Participant',
    intlKey: 'table.participant',
  //  sortableId: isActivityRegistration ? 'activity.award.participant.name' : 'award.participant.name'
  },
  {
    id: 7,
    label: 'Type',
    intlKey: 'table.type',
  },
  {
    id: 8,
    label: 'Activity',
    intlKey: 'table.activity',
 //   sortableId: 'activityCategory.name'
  },
  {
    id: 9,
    label: 'Invited by',
    intlKey: 'table.invited_by',
    hide: !isActivityRegistration
  },
  {
    id: 10,
    label: 'Requested',
    intlKey: 'table.requested'
  },
  {
    id: 11,
    label: 'Actions',
    intlKey: 'table.actions'
  }
]

export const tableHeadersAccount = () => [
  {
    id: 1,
    label: 'Name',
    intlKey: 'table.name',
    sortableId: 'name'
  },
  {
    id: 2,
    label: 'Email',
    intlKey: 'table.email',
    sortableId: 'email'
  },
  {
    id: 3,
    label: 'Phone number',
    intlKey: 'table.phone'
  },
  {
    id: 4,
    label: 'Invited by',
    intlKey: 'table.invited_by'
  },
  {
    id: 5,
    label: 'Requested',
    intlKey: 'table.requested'
  },
  {
    id: 6,
    label: 'Actions',
    intlKey: 'table.actions'
  }
]
